import axios from 'axios';
import { TIMEOUT_DELAY } from 'constants/general';

// Auth0's /oauth/token must get a bare request: the API client's `x-context-id` and expired Bearer
// header fail Auth0's CORS preflight, and its interceptors would treat that failure as the user
// being offline (or recurse into another refresh on a 401).
export const auth0TokenClient = axios.create({ timeout: TIMEOUT_DELAY.AXIOS });
